<template>
  <div id="pc">
    <router-view />
  </div>
</template>
<script>

export default {
  name: '',
  components: {
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
}
#app,
#pc {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.inline-block {
  display: inline-block;
}
.container {
  width: 80%;
  margin: 0 auto;
  position: relative;
}
</style>
